export default __webpack_public_path__ + "static/media/img2_plus2.60d91e3a.jpg";